module.exports = __webpack_public_path__ + "img/chrome.ea0f28af.png";